import { Stack } from "@mui/material";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import PrimaryButton from "../../../../common/PrimaryButton";
import { IFeedbackAndReviewProps } from "../../models";
import styles from "./feedBackAndReview.module.scss";
import { FeedbackAndReviewModal } from "./FeedbackAndReviewModal";

export const FeedbackAndReview = (props: IFeedbackAndReviewProps) => {
  const { t } = useTranslation();

  const {
    contract,
    setIsViewButtonFeedback,
    setOpenFeedbackAfterInspection,
    openFeedbackAfterInspection,
    refreshContractDetails,
  } = props;

  const toggleModal = () => {
    setOpenFeedbackAfterInspection && setOpenFeedbackAfterInspection();
  };

  const onReviewClick = () => {
    toggleModal();
  };

  return (
    <div>
      <FeedbackAndReviewModal
        modalOpen={openFeedbackAfterInspection}
        contract={contract}
        closeFeedbackModal={toggleModal}
        setIsViewButtonFeedback={setIsViewButtonFeedback}
        refreshContractDetails={refreshContractDetails}
      />

      <PrimaryButton
        id={`contract_details_open_feedback_modal`}
        onClick={onReviewClick}>
        <p className={classNames(styles.subtitle1, styles.white)}>
          {t("lbl_contract_review_and_feedback")}
        </p>
      </PrimaryButton>
    </div>
  );
};
